mainApp.directive('monitorQosItem', function() {
	return {
		templateUrl: '/public/directives/monitorQosItem.html',
		scope: {
			pid: '=',
			item: '=',
			dateRange: '=',
			segmentsNum: '=',
			accountId: '=',
		},
		controller: ['$scope', '$timeout', 'ChartsService', '$filter', 'DateRangeService', function ($scope, $timeout, ChartsService, $filter, DateRangeService) {
			var MIN_STATS_INTERVAL = 5000; // 5 seconds

			var directions = [
				{value: 'Up', label: 'Upstream', modifier: 1},
				{value: 'Down', label: 'Downstream', modifier: -1}
			];
			var charts = {
				throughputChart: {chart: null,setAxiScale: true},
				pktdiscardedChart: {chart: null,setAxiScale: true},
				latencyChart: {chart: null,setAxiScale: false},
			};
			$scope.destTypes = {
				CATO: 'Cato',
				ALTERNATIVE: 'Alternative WAN',
				LAYER_2_WAN: 'Alternative WAN (Layer-2)',
			};
			var syncTimeout;
			var currentCursor;

			$scope.interval = getInterval();

			// we only fetch data if we don't have it (haven't fetched before)
			if (!$scope.item.stats) {
				$scope.item.$$loadingInner = true;
				store.fetch({
					path: '/getPriorityQosData?accountId=' + $scope.accountId + '&pid=' + $scope.pid +
						'&priority=' + $scope.item.priority + '&fromDate=' + $scope.dateRange.from.getTime() +
						'&toDate=' + $scope.dateRange.to.getTime() + '&interval=' + $scope.interval,
					success: function(newPriorityData) {
						$timeout(function() {
							$scope.item.$$loadingInner = false;

							$timeout(function() {
								build(newPriorityData);
							}, 0, false);
						}, 0);
					}
				})
			} else {
				$timeout(function() {
					build();
				}, 0);
			}

			function build(newPriorityData) {
				if (newPriorityData) {
					parseInnerData(newPriorityData);
				}
				drawCharts();
				addGraphs();
				updateChartsData();
			}

			function parseInnerData(newPriorityData) {
				$scope.item.stats = [];
				$scope.item.topHosts = newPriorityData.topHosts;
				$scope.item.topApps = newPriorityData.topApps;
				parseTopList($scope.item.topHosts);
				parseTopList($scope.item.topApps);

				if (newPriorityData.interfaces) {
					newPriorityData.interfaces.forEach(function (inter) {
						if (inter.buckets) {
							inter.buckets.sort(function(a, b) {
								if (a.bucketStartTimestamp > b.bucketStartTimestamp) { return 1; } else if (a.bucketStartTimestamp < b.bucketStartTimestamp) { return -1; } else return 0;
							});
							inter.buckets.forEach(function(bucket, i) {
								var newBucket = $scope.item.stats[i] ? $scope.item.stats[i] : {};
								for (var statKey in bucket) {
									if (statKey === 'bucketStartTimestamp') {
										newBucket.timestamp = bucket[statKey] - (bucket[statKey]%1000);
									} else if (statKey === 'latency') {
										newBucket[inter.interfaceId + '_' + statKey] = bucket[statKey] ? Math.round(bucket[statKey]) : 0;
									} else  {
										newBucket[inter.interfaceId + '_' + statKey] = bucket[statKey] ? bucket[statKey].toFixed(1) : 0;
									}

									// we set downstream as negative to display in charts below 0
									if (statKey.indexOf('Down') >= 0) {
										newBucket[inter.interfaceId + '_' + statKey] = newBucket[inter.interfaceId + '_' + statKey] * -1;
									}
								}
								if (!$scope.item.stats[i]) {
									$scope.item.stats.push(newBucket);
								}
							});
						}
					});


				}
			}

			function parseTopList(topList) {
				if (!topList) return;

				topList.forEach(function(topItem) {
					topItem.name = topItem.itemId;
				});
			}

			function updateChartsData() {
				for (var chartKey in charts) {
					var chart = charts[chartKey];
					ChartsService.updateChart(chart.chart, $scope.item.stats, {setAxiScale: chart.setAxiScale});
				}
			}

			function addGraphs() {
				if ($scope.item.interfaces) {
					$scope.item.interfaces.forEach(function(inter, interCounter) {
						inter.graphs = [];
						inter.active = true;
						inter.graphsColor = ChartsService.graphColors[interCounter];
						directions.forEach(function(dir) {
							inter.graphs.push(ChartsService.newGraph(charts.throughputChart.chart, {
								type: 'line',
								id: 'throughput_' + dir.value + '_' + inter.interfaceId,
								title: 'Throughput ' + inter.interfaceName + ' ' + dir.label,
								valueField: inter.interfaceId + '_throughput' + dir.value,
								lineColor: inter.graphsColor,
								valueAxis: 'ValueAxis-1',
							}));
							inter.graphs.push(ChartsService.newGraph(charts.pktdiscardedChart.chart, {
								type: 'column',
								id: 'packetDiscarded_' + dir.value + '_' + inter.interfaceId,
								title: 'Packet Discarded ' + inter.interfaceName + ' ' + dir.label,
								valueField: inter.interfaceId + '_packetDiscarded' + dir.value,
								lineColor: inter.graphsColor,
								valueAxis: 'ValueAxis-1',
								balloonType: 'percent',
							}));
						});
						if (inter.hasLatency) {
							inter.graphs.push(ChartsService.newGraph(charts.latencyChart.chart, {
								type: 'line',
								id: 'latency_' + inter.interfaceId,
								title: 'Packets Delay ' + inter.interfaceName,
								valueField: inter.interfaceId + '_latency',
								lineColor: inter.graphsColor,
								valueAxis: 'ValueAxis-1',
								balloonType: 'time',
							}));
						}
					});
				}
			}

			function drawChart(elId, title, labelFunction) {
				var listeners = [{event: 'changed',method: syncCursors}, {event: 'init', method: setAfterInit}];
				var chartCursor = {
					cursorPosition: 'mouse',
					selectWithoutZooming: true,
					categoryBalloonDateFormat: 'JJ:NN:SS, MMM DD, YYYY',
					zoomable: true,
				};

				return AmCharts.makeChart(elId, ChartsService.getCommonSerialChartSettings({
					valueAxes: [
						ChartsService.getCommonValueAxis({
							id: 'ValueAxis-1',
							title: title,
							labelFunction: labelFunction,
						})
					],
					chartCursor: angular.copy(chartCursor),
					listeners: listeners,
				}));
			}

			function drawCharts() {
				charts.throughputChart.chart = drawChart('chart-throughput-' + $scope.item.priority, '', function(value) {
					return $filter('bits')(Math.abs(value), 1) + 'ps';
				});
				charts.pktdiscardedChart.chart = drawChart('chart-pcktdiscarded-' + $scope.item.priority, '', function(value) {
					return Math.abs(value) + '%';
				});
				charts.latencyChart.chart = drawChart('chart-latency-' + $scope.item.priority, '', function(value) {
					return value + 'ms';
				});
			}

			function syncCursors(e) {
				if (currentCursor && currentCursor !== e.chart.chartCursor) {
					return;
				}
				currentCursor = e.chart.chartCursor;

				if (syncTimeout) {
					$timeout.cancel(syncTimeout);
				}

				var index = e.chart.categoryAxis.xToIndex(e.x);

				if (e.index && e.index !== 0) {
					$scope.currIndex = index;
					syncTimeout = $timeout(function () {
						$scope.item.info = e.chart.dataProvider[index];
						currentCursor = null;
					}, 1);
				} else {
					$scope.currIndex = null;
					syncTimeout = $timeout(function () {
						$scope.item.info = null;
						currentCursor = null;
					}, 1);
				}
			}

			function setAfterInit(chart) {
				chart.chart.chartCursor.addListener('selected', handleZoom);
			}

			function handleZoom(event) {
				var start = Math.min(event.start, event.end);
				var end = Math.max(event.start, event.end);
				if (start && end) {
					DateRangeService.zoomTo(start, end, getInterval(start, end), false, {p:$scope.item.priority});
				}
			}

			function getInterval(from, to) {
				return Math.max(MIN_STATS_INTERVAL, parseInt(((from || $scope.dateRange.to.getTime()) - (to || $scope.dateRange.from.getTime())) / $scope.segmentsNum));
			}

			$scope.toggleInterGraphs = function(inter) {
				inter.graphs.forEach(function(graph) {
					inter.active ? graph.chart.hideGraph(graph) : graph.chart.showGraph(graph);
				});
				inter.active = !inter.active;
			};

			$scope.hasAlternativeWAN = function() {
				return $scope.item.interfaces.filter(function(inter) { return inter.hasLatency}).length !== $scope.item.interfaces.length && $scope.item.interfaces.length>0;
			}
		}]
	}
});
